import cn from 'clsx'

import { IoColorWandOutline } from 'react-icons/io5'

const TemplateNewPlaceholderForm = ({
    className,
    refNewPlaceholderKey,
    templatePlaceholders,
    newPlaceholderKey,
    setNewPlaceholderKey,
    newPlaceholderValue,
    onPlaceholderValueChange,
    onAddPlaceholderClick,
    onAddDefaultPlaceholdersClick,
    disabledProps,
}) => {
    
    return (
        
        <div className={cn(
            'TemplateNewPlaceholderForm',
            'flex items-center content-center justify-between form-group',
            className,
        )}>
            
            <input
                ref={refNewPlaceholderKey}
                className="w-full input input-bordered grow"
                type="text"
                value={newPlaceholderKey}
                placeholder="MyRunsheetName"
                autoComplete="off"
                {...disabledProps}
                onChange={e => setNewPlaceholderKey(e.target.value)} />
            
            <select
                className="w-auto pr-4 ml-3 select grow"
                value={newPlaceholderValue}
                {...disabledProps}
                onChange={onPlaceholderValueChange}>
                {templatePlaceholders.map(it => (
                    <option key={`placeholder-${it}`} value={it}>
                        {it}
                    </option>
                ))}
            </select>
            
            <button
                className="ml-3 btn btn-primary"
                {...disabledProps}
                onClick={onAddPlaceholderClick}>
                Add Placeholder
            </button>
            
            <button
                className="ml-3 btn btn-info"
                {...disabledProps}
                onClick={onAddDefaultPlaceholdersClick}>
                <IoColorWandOutline className="text-[1.40rem]" />
            </button>
        
        </div>
        
    )
    
}

export default TemplateNewPlaceholderForm
